import { render } from "./AudioMessage.vue?vue&type=template&id=26067255&scoped=true"
import script from "./AudioMessage.vue?vue&type=script&lang=js"
export * from "./AudioMessage.vue?vue&type=script&lang=js"

import "./AudioMessage.vue?vue&type=style&index=0&id=26067255&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26067255"]])

export default __exports__